"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormCompanyRegistrationNumber = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("@whitbread-eos/utils");
var _server = require("@whitbread-eos/utils/server");
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Button = require("../../Button");
var _FormInput = require("../FormInput");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FormCompanyRegistrationNumber = exports.FormCompanyRegistrationNumber = React.forwardRef((_ref, ref) => {
  var {
    id,
    value,
    setError,
    onLookupSuccess = () => {
      return;
    },
    onChange = () => {
      return;
    },
    onBlur = () => {
      return;
    },
    onFocus = () => {
      return;
    },
    errors,
    errorIcon,
    name,
    placeholder,
    disabled,
    className,
    scheme
  } = _ref;
  var {
    t
  } = (0, _server.useTranslation)(['payApplication']);
  var token = (0, _utils.getAuthCookie)();
  var [requestPending, setRequestPending] = (0, _react.useState)(false);
  var handleButtonClick = function () {
    var _ref2 = (0, _asyncToGenerator2.default)(function* () {
      setRequestPending(true);
      var result = yield (0, _server.companyDetailsLookup)(token, value, scheme);
      setRequestPending(false);
      if (result && result !== null && result !== void 0 && result.data && result.data.length > 0) {
        onLookupSuccess(result.data[0]);
      } else {
        setError(name, {
          type: 'custom',
          message: t('Invalid company registration number, please try again.')
        });
      }
    });
    return function handleButtonClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  return (0, _jsxRuntime.jsxs)("div", {
    className: className,
    children: [(0, _jsxRuntime.jsx)("div", {
      className: headingStyle,
      children: t('payApplication.companyDetails.registeredNumber')
    }), (0, _jsxRuntime.jsx)(_FormInput.FormInput, {
      className: inputStyle,
      id: id,
      name: name,
      value: value,
      placeholder: placeholder,
      errors: errors,
      errorIcon: errorIcon,
      disabled: disabled,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      ref: ref
    }), (0, _jsxRuntime.jsx)(_Button.Button, {
      variant: "outline",
      onClick: handleButtonClick,
      disabled: disabled || requestPending,
      className: buttonStyle,
      children: t('payApplication.companyDetails.findCompanyDetails')
    })]
  });
});
FormCompanyRegistrationNumber.displayName = 'Form Company Registration Number';
var headingStyle = 'font-bold text-xl';
var inputStyle = 'mt-6';
var buttonStyle = 'w-full mt-6 font-semibold text-lg';